/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import type {
  Organization,
  SaasOrganizationResponse,
  SaasUserResponse,
} from '@modules/cloud-api/v1/types'
import {
  createOrganizationUrl,
  getSaasCurrentUserUrl,
  GetSaasCurrentUserUrlParams,
  getSaasOrganizationUrl,
  refreshSaasCurrentUserUrl,
} from '@modules/cloud-api/v1/urls'
import { fetchAsJson } from '@modules/query/helpers'
import type { UserProfileFromApi } from '@modules/ui-types'

export const getUserProfile: () => Promise<{ user: UserProfileFromApi }> = () =>
  fetchAsJson<SaasUserResponse>(getSaasCurrentUserUrl(), {
    method: 'get',
    headers: {
      Authorization: '',
    },
  }).then((val) => ({
    user: {
      ...val.user,
      ...val.rules,
      ...val.subscription,
      trials: val.trials,
    } as UserProfileFromApi,
  }))

export const getOrganization = async ({ organizationId }: { organizationId: string }) =>
  fetchAsJson<SaasOrganizationResponse>(getSaasOrganizationUrl({ organizationId }), {
    method: 'get',
    headers: {
      Authorization: '',
    },
  })

export const createOrganization = async ({ name }: { name?: string }) =>
  fetchAsJson<Organization>(createOrganizationUrl(), {
    method: 'post',
    body: JSON.stringify({
      name,
    }),
    headers: {
      Authorization: '',
    },
  })

export const postRefreshToken = async () =>
  fetchAsJson(refreshSaasCurrentUserUrl(), {
    method: 'post',
  })

export const getSaasUser: (params?: GetSaasCurrentUserUrlParams) => Promise<SaasUserResponse> = (
  params,
) =>
  fetchAsJson<SaasUserResponse>(getSaasCurrentUserUrl(params), {
    method: 'get',
    headers: {
      Authorization: '',
    },
  })
